import React, { useState, useEffect } from 'react';

// Simple "fog screen" gate in front of the whole site while it's under active
// development. Not a real security boundary (the password is bundled into
// the JS, like any client-side check) - it's meant to keep casual visitors,
// search crawlers and link-sharing from landing on an unfinished site, not
// to stop a determined attacker. Once unlocked, access is remembered in this
// browser via localStorage, so normal use (including the real app) is never
// interrupted again.

const STORAGE_KEY = 'za_site_gate_unlocked';
const SITE_PASSWORD = process.env.REACT_APP_SITE_PASSWORD;

const C = {
  bg: '#0b1120',
  card: '#111827',
  border: 'rgba(56,189,248,0.35)',
  text: '#e2e8f0',
  sub: '#94a3b8',
  logoBlue: '#38bdf8',
  error: '#f87171',
};

export default function SiteGate({ children }) {
  const [unlocked, setUnlocked] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (unlocked) {
      try { localStorage.setItem(STORAGE_KEY, 'true'); } catch {}
    }
  }, [unlocked]);

  // If no password is configured (e.g. local dev without the env var set),
  // never block access - avoids locking developers out accidentally.
  if (!SITE_PASSWORD) return children;
  if (unlocked) return children;

  const submit = (e) => {
    e.preventDefault();
    if (value === SITE_PASSWORD) {
      setUnlocked(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: C.bg, padding: 20, fontFamily: 'inherit',
    }}>
      <form onSubmit={submit} style={{
        width: '100%', maxWidth: 360, background: C.card, border: `1px solid ${C.border}`,
        borderRadius: 16, padding: '32px 28px', boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
      }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: C.logoBlue, marginBottom: 6 }}>
          ZenAnalytics.io
        </div>
        <div style={{ fontSize: 14, color: C.sub, marginBottom: 20 }}>
          Password required
        </div>
        <input
          type="password"
          autoFocus
          value={value}
          onChange={(e) => { setValue(e.target.value); setError(false); }}
          placeholder="Salasana"
          style={{
            width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8,
            border: `1px solid ${error ? C.error : C.border}`, background: '#0f172a',
            color: C.text, fontSize: 15, marginBottom: 12, outline: 'none',
          }}
        />
        {error && (
          <div style={{ color: C.error, fontSize: 13, marginBottom: 12 }}>
            Väärä salasana.
          </div>
        )}
        <button type="submit" style={{
          width: '100%', padding: '10px 12px', borderRadius: 8, border: 'none',
          background: C.logoBlue, color: '#0b1120', fontWeight: 700, fontSize: 15,
          cursor: 'pointer',
        }}>
          Continue →
        </button>
      </form>
    </div>
  );
}
